import axios from "axios";

// Custom domains: when the page is served from the backend's own domain (with or without "www."),
// talk to the same origin so cookies + CORS never depend on which variant the visitor typed.
const resolveBackend = () => {
  const env = process.env.REACT_APP_BACKEND_URL;
  try {
    const envHost = new URL(env).hostname.replace(/^www\./, "");
    const here = window.location.hostname.replace(/^www\./, "");
    if (envHost === here) return window.location.origin;
  } catch (_) { /* fall through */ }
  return env;
};
const BACKEND_URL = resolveBackend();
export const API_BASE = `${BACKEND_URL}/api`;
export const WS_BASE = BACKEND_URL.replace(/^http/, "ws") + "/api";
export const BACKEND_ORIGIN = BACKEND_URL;

export const SA_ORG_KEY = "sa_org_id";

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Super-admins can act inside another organization by selecting it in the header.
api.interceptors.request.use((config) => {
  const org = localStorage.getItem(SA_ORG_KEY);
  if (org) config.headers["X-Org-Id"] = org;
  return config;
});

// Read-only demo guests get a clear explanation instead of a bare 403.
api.interceptors.response.use(undefined, (error) => {
  if (error.response?.status === 403 && error.response?.data?.detail === "DEMO_READ_ONLY") {
    import("sonner").then(({ toast }) =>
      toast.info("Demo account is read-only — look around all you like, nothing can be changed."));
  }
  return Promise.reject(error);
});

// Direct browser links (PDF / CSV in a new tab) can't carry the X-Org-Id header — append the same
// org override as a query param so super-admin / demo-mode downloads resolve in the selected org.
export function apiHref(path) {
  const org = localStorage.getItem(SA_ORG_KEY);
  if (!org) return `${API_BASE}${path}`;
  return `${API_BASE}${path}${path.includes("?") ? "&" : "?"}org_id_override=${encodeURIComponent(org)}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
